<template>
  <transition name="slide">
    <div
      v-if="toggle.feedback && (!isFeedbackModalVisible) && showFeedback"
      class="feedback-banner"
      @click="openFeedbackModal"
    >
      <div class="banner-content">
        <div>
          <div class="feedback-pesquisa">
            <h3 class="feedback-pesquisa-text">
              PESQUISA
            </h3>
          </div>
          <h4 class="feedback-text">
            {{ text }}
          </h4>
        </div>
        <feedback-grade />
      </div>
    </div>
  </transition>
</template>

<script>
import feedbackGrade from './FeedbackGrade.vue'
import {feedback, feedbackMapping} from '@/api/feedback'
import mixin from './feedbackMixin'
import { mapGetters } from 'vuex'

export default {
  components: {
    'feedback-grade': feedbackGrade
  },
  mixins: [mixin],
  props: [
    'feedbackStep',
    'text'
  ],
  computed: {
    ...mapGetters(['toggle']),
    showFeedback: function () {
      let feedbackConfig = feedbackMapping[this.feedbackStep]

      return feedback.feedbackCounters[feedbackConfig.counter] > feedbackConfig.limit
    }
  },
  methods: {
    openFeedbackModal () {
      feedback.feedbackInProgress = this.feedbackStep
    }
  }
}
</script>

<style lang="scss">
  .slide-enter-active, .slide-leave-active {
    transition: all .5s
  }

  .slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translateY(111px);
  }

  .feedback-banner {
    position: fixed;
    bottom: 0;
    height: 111px;
    width: 100%;
    background: #fff;
    z-index: 1000;
    cursor: pointer;
    box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.06), 0 0 24px 0 rgba(0, 0, 0, 0.12);
    left: 0;

    .feedback-grade {
      pointer-events: none;

      button {
        pointer-events: none;
      }
    }

    .banner-content {
      max-width: 760px;
      margin: 0 auto;
      background: url("/static/images/nps-avatar.png")0 19px no-repeat;
      padding-left: 129px;
      height: 100%;
      display: flex;
    }

    .feedback-pesquisa {
      background: #7f1a54;
      width: 58px;
      height: 13px;
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .feedback-pesquisa-text {
      font-size: 10px;
      font-weight: 400;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: 0.8px;
      text-align: left;
      color: #fff;
      padding-left: 3px;
      padding-top: 1px;
    }

    .feedback-text {
      margin-top: 6px;
      width: 214px;
      height: 42px;
      font-size: 18px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: -0.2px;
      text-align: left;
      color: #303030;
    }

    .feedback-grade{
      margin: 0 0 0 25px;

      &__button {
        width: 70px;
        height: 79px;
        font-size: 10px;
        text-align: center;

        img{
          width: 30px;
          margin: 0 auto 10px;
          display: block;
        }
      }
    }
  }
</style>
